var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4442 6.4245C10.0808 6.36782 9.7581 6.62314 9.706 6.98716C9.57511 7.90142 9.16348 8.73561 8.51551 9.39982C6.86635 11.0903 4.18497 11.089 2.53646 9.39982C0.88828 7.70998 0.88828 4.96037 2.53646 3.27087C3.15646 2.63566 3.93914 2.2215 4.81511 2.07073C5.19182 1.99745 5.59683 1.98478 6.01705 2.03359C6.59405 2.10167 7.13111 2.29792 7.6212 2.58605L6.7743 2.73428C6.42049 2.79649 6.18221 3.14097 6.24323 3.50398C6.29722 3.82892 6.57232 4.05844 6.88359 4.05844C6.91982 4.05844 6.95664 4.05551 6.99411 4.04897L9.2645 3.65108C9.43408 3.62114 9.58591 3.52346 9.6857 3.37889C9.78542 3.23466 9.82484 3.05555 9.79557 2.88105L9.40676 0.554065C9.34705 0.191384 9.01542 -0.051536 8.65589 0.00934417C8.30208 0.071558 8.0638 0.416368 8.12482 0.779382L8.22714 1.39185C7.59752 1.02977 6.90297 0.795518 6.16504 0.708432C5.61237 0.643951 5.07623 0.661889 4.58549 0.758243C3.45569 0.952286 2.42913 1.49507 1.61658 2.32792C-0.538861 4.53741 -0.538861 8.13261 1.61658 10.3427C2.69428 11.4477 4.11029 12 5.52599 12C6.942 12 8.35731 11.4478 9.43539 10.3427C10.2822 9.47464 10.8209 8.38133 10.993 7.1812C11.0452 6.81652 10.7993 6.47784 10.4442 6.4245Z",
    fill: "#498AE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIReload);
export default __webpack_public_path__ + "static/media/i-reload.d23e0d9ab334f95d34cd57beba25935b.svg";
export { ForwardRef as ReactComponent };